/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Reference_Entry_HintInputs */

const en_reading_class_reference_entry_hint = /** @type {(inputs: Reading_Class_Reference_Entry_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The list of sources at the end`)
};

const es_reading_class_reference_entry_hint = /** @type {(inputs: Reading_Class_Reference_Entry_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La lista de fuentes al final`)
};

/**
* | output |
* | --- |
* | "The list of sources at the end" |
*
* @param {Reading_Class_Reference_Entry_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_reference_entry_hint = /** @type {((inputs?: Reading_Class_Reference_Entry_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Reference_Entry_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_reference_entry_hint(inputs)
	return en_reading_class_reference_entry_hint(inputs)
});